/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectOptimizeStartedDtoBase
 * auto generated base class for the model ProjectOptimizeStartedDtoModel.
 *
 * Optimize started
 */
export const ProjectOptimizeStartedDtoModelBase = ModelBase
  .named('ProjectOptimizeStartedDto')
  .props({
    __typename: types.optional(types.literal("ProjectOptimizeStartedDto"), "ProjectOptimizeStartedDto"),
    projectId: types.union(types.undefined, types.string),
    solutionId: types.union(types.undefined, types.string),
    /** Count of visits submitted */
    visitsCount: types.union(types.undefined, types.number),
    /** Count of routes submitted */
    routesCount: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectOptimizeStartedDtoModelSelector extends QueryBuilder {
  get projectId() { return this.__attr(`projectId`) }
  get solutionId() { return this.__attr(`solutionId`) }
  get visitsCount() { return this.__attr(`visitsCount`) }
  get routesCount() { return this.__attr(`routesCount`) }
}
export function selectFromProjectOptimizeStartedDto() {
  return new ProjectOptimizeStartedDtoModelSelector()
}

export const projectOptimizeStartedDtoModelPrimitives = selectFromProjectOptimizeStartedDto().projectId.solutionId.visitsCount.routesCount
